import { render, staticRenderFns } from "./ReportHighlightsComponent.vue?vue&type=template&id=7198317c"
import script from "./ReportHighlightsComponent.vue?vue&type=script&lang=js"
export * from "./ReportHighlightsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports